import { observable, action, decorate } from 'mobx'
import i18n from "../i18n/config"
import moment from 'moment'

class CommonStore {
  token = localStorage.getItem('jwt')
  isLoading = false
  isRemember = true
  isSidebarCollapse = false
  appTheme = {
    name: 'default',
    solidColor: '#F26524',
    solidLightColor: '#ecf9f6',
    gradientColor: 'linear-gradient(167.51deg, #f26524 24.37%, #f26524 78.07%)',
    shadowColor: '0 2px 10px rgba(46,207,148,0.6)',
  }
  cameraPosition = undefined
  cameraHeadingPitchRoll = undefined
  showMainDrawer = false
  showLicenseDrawer = false
  showOrganizationPageDrawer = false
  showUserSettingPageDrawer = false
  currentPage = ''
  currentMainDrawerPanel = 'cityDemo'
  buttonSize = 'default'
  buttonSizeNormal = 'default'
  deviceId = undefined;
  devices = [];
  showCalibrationManual = false;
  cameraCesium = undefined
  enableShadows = false;
  nearValue = 0
  farDistance = 2000
  nearDistance = 200
  GPSUpdate = true;
  backgroundColorSetting = '#80664d'
  manualGpsState = 0
  manualOrientationState = 0
  manualGPSPosition = undefined
  ambientViewModel = {
    intensity: 1.0,
    bias: 0.4,
    lengthCap: 0.3,
    stepSize: 2,
    frustumLength: 100,
    blurStepSize: 2
  };
  pickedObject = {};
  language = "en";
  useAbsoluteOrientation = true
  cameraFov = undefined

  setCameraFov = (fov) =>{
    this.cameraFov = fov
  }

  getPositionHash(position) {
    return `${position.x}-${position.y}-`
  }
  comparePosition(positionA, positionB) {
    return positionA.x === positionB.x && positionA.y === positionB.y
  }
  getPickedObject(position) {
    if (this.pickedObject.position && this.pickedObject.object) {
      if (this.comparePosition(this.pickedObject.position, position)) {
        return this.pickedObject.object
      }
    }
  }
  setpickedObject = (object, position) => {
    console.log('setpickedObject', position)
    if (position) {
      this.pickedObject = {
        position: {
          x: position.x,
          y: position.y
        }, object: object
      }
    } else {
      this.pickedObject = {}
    }
  }

  setBackgroundColorSetting = color => {
    this.backgroundColorSetting = color
  }

  setNearValue = number => {
    this.nearValue = number
  }

  setFarDistance = number => {
    this.farDistance = number
  }

  setNearDistance = number => {
    this.nearDistance = number
  }

  setAmbientViewModel = v => {
    Object.assign(this.ambientViewModel, v)
  }
  setGPSUpdate = status => {
    this.GPSUpdate = status
  }
  setManualGPSPosition = p => {
    this.manualGPSPosition = p
  }
  setManualGPS = status => {
    this.manualGpsState = status
  }
  setManualOrientationState = status => {
    this.manualOrientationState = status
    // if (status === 1) {
    //   this.setUseAbsoluteOrientation(false)
    // }
    // if (status === 0) {
    //   this.setUseAbsoluteOrientation(true)
    // }
  }

  setUseAbsoluteOrientation = (status) => {
    this.useAbsoluteOrientation = status
  }
  setenableShadows(b) {
    this.enableShadows = b;
  }
  verticalCalibration = this.getLocalVerticalCalibration();
  horizontalCalibration = this.getLocalHorizontalCalibration();
  setShowCalibrationManual(isShow) {
    this.showCalibrationManual = isShow
  }
  enableHighAccuracy = true;
  setenableHighAccuracy(b) {
    this.enableHighAccuracy = b;
  }
  openSensorSetting = false;
  setopenSensorSetting(c) {
    this.openSensorSetting = c;
  }
  setcameraCesium(c) {
    this.cameraCesium = c;
  }
  setCameraPossition(p) {
    this.cameraPosition = p;
  }
  setCameraHeadingPitchRoll(p) {
    this.cameraHeadingPitchRoll = p;
  }
  setShowLicenseDrawer = status => {
    this.showLicenseDrawer = status
  }

  getLocalVerticalCalibration() {
    const value = localStorage.getItem('verticalCalibration');
    if (!isNaN(value)) return Number(value);
    return 0;
  }
  getLocalHorizontalCalibration() {
    const value = localStorage.getItem('horizontalCalibration');
    if (!isNaN(value)) return Number(value);
    return 0;
  }
  setVerticalCalibration(value) {
    this.verticalCalibration = value
    localStorage.setItem('verticalCalibration', this.verticalCalibration)
  }
  setHorizontalCalibration(value) {
    this.horizontalCalibration = value
    localStorage.setItem('horizontalCalibration', this.horizontalCalibration)
  }
  setDeviceId(deviceId) {
    this.deviceId = deviceId
  }

  setDevices(devices) {
    this.devices = devices
  }

  setToken(token) {
    this.token = token
  }

  setLoadingProgress = state => {
    this.isLoading = state
  }

  setCurrentMainDrawerPanel(currentPanel) {
    this.currentMainDrawerPanel = currentPanel
  }

  setShowMainDrawer(isShow) {
    this.showMainDrawer = isShow
  }

  setShowOrganizationPageDrawer(isShow) {
    this.showOrganizationPageDrawer = isShow
  }

  setShowUserSettingPageDrawer(isShow) {
    this.showUserSettingPageDrawer = isShow
  }


  setCurrentPage(pageName) {
    this.currentPage = pageName
  }

  checkToken() {
    if (this.token) return true
    return !!(localStorage.jwt || sessionStorage.jwt)
  }

  clearToken() {
    localStorage.clear()
    sessionStorage.clear()
  }

  setRemember(isRemember) {
    this.isRemember = isRemember
  }

  setLoadingProgress = state => {
    this.isLoading = state
  }

  setTheme(color) {
    switch (color) {
      case 'red':
        this.appTheme.name = 'red'
        this.appTheme.solidColor = 'rgb(244, 67, 54)'
        this.appTheme.solidLightColor = 'rgb(254, 237, 235)'
        this.appTheme.gradientColor =
          'linear-gradient(108.84deg, #F77062 0%, #FE5196 100%)'
        this.appTheme.shadowColor = '0 2px 10px rgba(254, 81, 150, 0.5)'
        break
      default:
        this.appTheme.name = 'green'
        this.appTheme.solidColor = '#222'
        this.appTheme.solidLightColor = '#fff'
        this.appTheme.gradientColor =
          'linear-gradient(167.51deg, #fff 24.37%, #fff 78.07%)'
        this.appTheme.shadowColor = '0 2px 10px rgba(46,207,148,0.6)'
        break
    }
  }

  setLanguage(lang) {
    i18n.changeLanguage(lang)
    this.language = lang;
  }

   loggingFunction (action,status,startTime,user,project,organization){
    const endTime = Date.now();
    const getElapsedTime = (startTime, endTime) => {
      const elapsedTimeInSeconds  = endTime - startTime;
      const time = elapsedTimeInSeconds / 1000 ;
      return time ;
    }
    let time = getElapsedTime(startTime,endTime);
    let message = moment().format('YYYY-MM-DD-h:mm:ss a :');
    if(user) message += ` ${user?.username || user?.email || 'public user'}`;
    if(action) message += `, ${action}` ;
    if(status) message += `, ${status}` ;
    if(startTime) message += `, ${startTime}`;
    if(endTime) message += `, ${endTime}`;
    if(time) message += `, ${time}s`;
    if(project) message += `, ${project}`;
    if(organization) message += `, ${organization}`;
    console.log(message);
  }
}

decorate(CommonStore, {
  token: observable,
  setToken: action,
  checkToken: action,
  clearToken: action,

  showMainDrawer: observable,
  setShowMainDrawer: action,

  showOrganizationPageDrawer: observable,
  setShowOrganizationPageDrawer: action,

  showUserSettingPageDrawer: observable,
  setShowUserSettingPageDrawer: action,

  currentPage: observable,
  setCurrentPage: action,

  currentMainDrawerPanel: observable,
  setCurrentMainDrawerPanel: action,

  isLoading: observable,
  setLoadingProgress: action,

  isRemember: observable,
  setRemember: action,

  appTheme: observable,
  setTheme: action,
  deviceId: observable,
  devices: observable,
  setDeviceId: action,
  setDevices: action,
  showCalibrationManual: observable,
  verticalCalibration: observable,
  horizontalCalibration: observable,
  setShowCalibrationManual: action,

  setVerticalCalibration: action,
  setHorizontalCalibration: action,
  setcameraCesium: action,
  cameraCesium: observable,

  cameraPosition: observable,
  setCameraPossition: action,
  enableHighAccuracy: observable,
  setenableHighAccuracy: action,
  openSensorSetting: observable,
  setopenSensorSetting: action,
  enableShadows: observable,
  setenableShadows: action,
  ambientViewModel: observable,
  setAmbientViewModel: action,

  showLicenseDrawer: observable,
  setShowLicenseDrawer: action,
  setCameraHeadingPitchRoll: action,
  cameraHeadingPitchRoll: observable,
  setNearValue: action,
  nearValue: observable,
  setFarDistance: action,
  setNearDistance: action,
  nearDistance: observable,
  farDistance: observable,
  setGPSUpdate: action,
  GPSUpdate: observable,
  setManualGPS: action,
  backgroundColorSetting: observable,
  setBackgroundColorSetting: action,
  manualGpsState: observable,
  setManualOrientationState: action,
  manualOrientationState: observable,
  setpickedObject: action,
  pickedObject: observable,
  getPickedObject: action,
  setLanguage: action,
  language: observable,

  useAbsoluteOrientation: observable,
  setUseAbsoluteOrientation: action,

  cameraFov: observable,
  setCameraFov: action,
  loggingFunction : action
})

export default new CommonStore()
